module.exports = __webpack_public_path__ + "img/img_xinshou_9.ef5911a8.png";